<script lang="ts" generic="T" setup>
// TODO провести рефакторинг
import './style.scss';

import type { ModelRef } from 'vue';
import type { UiInputCheckProps } from './types';

const className = 'ui-check';

const {
  id,
  label,
  info,
  color = 'default',
} = defineProps<UiInputCheckProps>();

const model = defineModel<T>({ required: true }) as ModelRef<string>;

const emit = defineEmits<{ onChange: [value: string | undefined] }>();

const onChange = () => {
  emit('onChange', model.value);
};
const inputId = id || useId();
</script>

<template>
  <div :class="[className, `${className}_${color}`]">
    <input
      :id="inputId"
      v-model="model"
      type="checkbox"
      :class="`${className}__input`"
      @change="onChange"
    >
    <div
      v-if="label || info"
      :class="`${className}__text`"
    >
      <label
        v-if="label"
        :for="inputId"
        :class="`${className}__label`"
      >
        {{ label }}
      </label>
      <p
        v-if="info"
        :class="`${className}__message ${className}__message_info`"
      >
        {{ info }}
      </p>
    </div>
  </div>
</template>
